/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { OrangeBackground, SuccessContainer, Div, Span, TextGrey } from 'components/styles/index';
import { Button } from 'components/button/button';
import CheckedIcon from 'assets/images/checked.png';
import { useHistory } from 'react-router-dom';
import { DashboardHeader } from 'components/dashboard-header/dashboard-header';
import { getConsents } from 'api/bank';
import { formatConsentAccessUntil } from 'utils/date-function';
import moment from 'moment';

const consentCreatedAt = (consent) =>
   consent?.createAt || consent?.createdAt || consent?.created_at;

const RedirectionSuccess = () => {
   const history = useHistory();
   const [accessUntil, setAccessUntil] = useState(() => formatConsentAccessUntil());

   useEffect(() => {
      (async () => {
         try {
            const result = await getConsents({ bankName: 'all' });
            const list = result?.ok ? result?.data?.data : [];
            if (!Array.isArray(list) || list.length === 0) {
               return;
            }
            const latest = [...list].sort((a, b) => {
               const da = moment(consentCreatedAt(a));
               const db = moment(consentCreatedAt(b));
               return db.valueOf() - da.valueOf();
            })[0];
            setAccessUntil(formatConsentAccessUntil(consentCreatedAt(latest)));
         } catch (err) {
            console.error('Unable to load consent expiry', err);
         }
      })();
   }, []);

   return (<>
      <DashboardHeader />
      <OrangeBackground>
         
         <SuccessContainer>
            <div>
               <img src={CheckedIcon} alt="icon" />
            </div>
            <Div className="font-22 font-bold text-black">Thank You</Div>
            <Div className="font-16 font-regular">
               We have received the requested information from your selected account(s)
            </Div>
            <TextGrey className="font-16 font-regular">
               We will access your information from your accounts until{' '}
               <Span className="text-green">{accessUntil}</Span>
            </TextGrey>
            <Div className="d-flex justify-content-center">
               <div>
                  <Button variant="primary" onClick={() => history.push('/dashboard')}>
                     View Dashboard
                  </Button>
               </div>
               <Div className="ml-20">
                  <Button variant="secondary" onClick={() => history.push('/manage-plan')}>
                     View Plan
                  </Button>
               </Div>
            </Div>
         </SuccessContainer>
      </OrangeBackground>
      </>
   );
};

export default RedirectionSuccess;
